import { CrudList } from '../shared/CrudPage';
import { branchService } from '@kss/api';
import type { Branch, BranchCreate, BranchFilter } from '@kss/api';

export default function AllBranches() {
  return (
    <CrudList<Branch, BranchCreate, BranchFilter>
      title="Branchs"
      newLabel="New branch"
      service={branchService}
      idKey="branchId"
      labelKey="name"
      basePath="/panel/branches"
      columns={[
        { accessor: 'code', title: 'Code', sortable: true, filterable: true, width: 120 },
        { accessor: 'name', title: 'Name', sortable: true, filterable: true },
        { accessor: 'branchType' as never, title: 'Type', width: 130 },
        { accessor: 'city' as never, title: 'City', width: 140 },
        { accessor: 'phone' as never, title: 'Phone', width: 140 },
      ]}
    />
  );
}
